/* eslint-disable no-inner-declarations */
'use strict';

import modules from './helpers/modules';

function launchApplePay(action, location, ApplePaySession) {
    // Check if the session is available
    if (window.SFRA.SitePreferences.enableApplePayApi && window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
        var request;
        var APPLE_PAY_VERSION = window.SFRA.SitePreferences.applePayVersion;
        var redirect;
        var updatedRequest;
        var session;
        var ATTR_SKU = 'sku';
        var ATTR_PAGE = 'page';
        var applePayApiButton = $('.apple-pay-api-button');
        var applePayApiInitialButton = $('.apple-pay-api-initial-button');
        var conditionOfSales = $('#condition-of-sales');

        if (location.protocol !== 'https:' || !ApplePaySession.supportsVersion(APPLE_PAY_VERSION)) {
            return;
        }

        function handleResponse(response) {
            return response.json()
                .then(function(json) {
                    if (response.status >= 200 && response.status < 300) {
                        // Return success JSON response
                        return json;
                    }
                    // Throw error with response status
                    var err = new Error(json ? json.status : 'Request error');
                    err.response = json;
                    throw err;
                });
        }

        /* Filter out properties that are not from Event prototype,
        * and include all others as ownProperty to a new object.
        * @param {Event} e
        * @return {Object} object with relevant properties as ownProperty
        */
        function filterEvent(e) {
            var filteredEvent = {};
            for (var prop in e) {
                if (!Event.prototype.hasOwnProperty(prop)) {
                    filteredEvent[prop] = e[prop];
                }
            }
            return filteredEvent;
        }

        function postJson(url, data) {
            var json = data;
            if (typeof data === 'object') {
                json = JSON.stringify(data);
            } else if (typeof data !== 'string') {
                throw new Error('Data must be an object or a JSON string.');
            }
            return fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: json
            }).then(handleResponse);
        }

        function doRedirect() {
            if (redirect) {
                // Redirect to last responded redirect
                location.href = redirect;
            }
        }

        function processServerResponse(response) {
            if (!response) {
                return;
            }
            // redirect could be an empty string
            if (typeof response.redirect !== 'undefined') {
                // set redirect URL
                redirect = response.redirect;
            }
        }

        function getJson(url) {
            return fetch(url, {
                credentials: 'include',
                headers: {
                    'Accept': 'application/json'
                }
            }).then(handleResponse);
        }

        function updateAppleErrorObject(response) {
            if (response.ApplePayErrors && response.ApplePayErrors.length > 0) {
                response['errors'] = [];
                response.ApplePayErrors.forEach(function(error) {
                    // eslint-disable-next-line no-undef
                    var applePayError = new ApplePayError(error.code, error.contactField, error.message);
                    response['errors'].push(applePayError);
                })
                delete response.ApplePayErrors;
                return response;
            }
            return response;
        }

        /**
         * On successful creation of an order, submit it through a form
         * @param {String} formAction URL to which to POST form to
         */
        function submitOrder(formAction) {
            var form = document.createElement('form');
            form.action = formAction;
            form.method = 'post';

            document.body.appendChild(form);
            form.submit();
        }

        function oncancelHandler() {
            setSession(null);

            postJson(action.cancel, {}).then(function(response) {
                processServerResponse(response);
                doRedirect();
            }, function(error) {
                processServerResponse(error.response);
                doRedirect();
            })
        }

        function onpaymentauthorizedHandler(e) {
            postJson(action.onpaymentauthorized, filterEvent(e)).then(function(response) {
                session.completePayment(ApplePaySession.STATUS_SUCCESS);
                setSession(null);
                submitOrder(response.result.redirect);
            }, function(error) {
                error.response = updateAppleErrorObject(error.response.result);
                if (error.response.errors && error.response.errors.length > 0) {
                    session.completePayment(error.response);
                } else {
                    session.completePayment({
                        status: ApplePaySession.STATUS_FAILURE
                    })
                }
                processServerResponse(error.response);
                doRedirect();
            })
        }

        function onpaymentmethodselectedHandler(e) {
            postJson(action.onpaymentmethodselected, filterEvent(e)).then(function(response) {
                // update updatedRequest with new server response
                updatedRequest.total = response.update.newTotal;
                if (response.update.newLineItems && response.update.newLineItems.length > 0) {
                    updatedRequest.lineItems = response.update.newLineItems;
                }
                if (session == null || session == undefined) {
                    return;
                }
                session.completePaymentMethodSelection(response.update);
                processServerResponse(response);
            }, function(error) {
                // No way to communicate error status on this event to Apple Pay
                if (session == null || session == undefined) {
                    return;
                }
                session.completePaymentMethodSelection(error.response);
                processServerResponse(error.response);
            })
        }

        function onshippingcontactselectedHandler(e) {
            postJson(action.onshippingcontactselected, filterEvent(e)).then(function(response) {
                // update updatedRequest with new server response
                updatedRequest.total = response.update.newTotal;
                updatedRequest.lineItems = response.update.newLineItems;
                updatedRequest.shippingMethods = response.update.newShippingMethods;
                if (session == null || session == undefined) {
                    return;
                }
                session.completeShippingContactSelection(response.update);
                processServerResponse(response.update);
            }, function(error) {
                error.response = updateAppleErrorObject(error.response.update);
                if (session == null || session == undefined) {
                    return;
                }
                session.completeShippingContactSelection(error.response);
                processServerResponse(error.response);
            })
        }

        function onshippingmethodselectedHandler(e) {
            postJson(action.onshippingmethodselected, filterEvent(e)).then(function(response) {
                // update updatedRequest with new server response
                updatedRequest.total = response.update.newTotal;
                updatedRequest.lineItems = response.update.newLineItems;
                if (session == null || session == undefined) {
                    return;
                }
                session.completeShippingMethodSelection(response.update);
                processServerResponse(response.update);
            }, function(error) {
                if (session == null || session == undefined) {
                    return;
                }
                session.completeShippingMethodSelection(error.response);
                processServerResponse(error.response);
            })
        }

        /**
		 * Prepares an Apple Pay basket, optionally
		 * containing exclusively the product with the given SKU to buy.
		 * @param {String} [sku] SKU of product to buy
		 */
        function prepareBasket(sku, page) {
            postJson(action.prepareBasket, {
                sku: sku,
                page: page
            }).then(function(response) {
                processServerResponse(response);
                // applepay GMT data tracking
                var apple_pay_page = page === 'pdp' ? 'product detail page' : page === 'cart' ? 'cart' : page === 'minicart' ? 'minicart' : 'delivery';
                if (page === 'pdp') {
                    modules.tracking.init(null, {
                        trackEvent: 'apple_pay',
                        trackObject: {
                            asyncURL: window.SFRA.Urls.GTMEventView,
                            asyncParams: {
                                apple_pay_page: apple_pay_page,
                                pid: sku
                            }
                        }
                    });
                } else {
                    modules.tracking.init(null, {
                        trackEvent: 'apple_pay',
                        trackObject: {
                            apple_pay_page: apple_pay_page
                        }
                    });
                }
            }, function(error) {
                try {
                    session.abort();
                } catch (e) {
                    return;
                }
                processServerResponse(error.response);
                doRedirect();
            })
        }

        function onvalidatemerchantHandler(e) {
            postJson(action.onvalidatemerchant, Object.assign(filterEvent(e), {
                hostname: window.location.hostname
            })).then(function(response) {
                if (session == null || session == undefined) {
                    return;
                }
                session.completeMerchantValidation(response.session);
            }, function() {
                session.abort();
            })
        }

        function setSession(s) {
            if (session) {
                session.oncancel = null;
                session.onpaymentauthorized = null;
                session.onpaymentmethodselected = null;
                session.onshippingcontactselected = null;
                session.onshippingmethodselected = null;
                session.onvalidatemerchant = null;
            }

            session = s;

            if (session) {
                session.oncancel = oncancelHandler;
                session.onpaymentauthorized = onpaymentauthorizedHandler;
                session.onpaymentmethodselected = onpaymentmethodselectedHandler;
                session.onshippingcontactselected = onshippingcontactselectedHandler;
                session.onshippingmethodselected = onshippingmethodselectedHandler;
                session.onvalidatemerchant = onvalidatemerchantHandler;
            }
        }

        /**
         * Retrieves Apple Pay request info from the server.
         */
        function getRequest() {
            getJson(action.getRequest).then(function(response) {
                request = Object.assign({}, response.responseObj);
                if (applePayApiButton) {
                    applePayApiButton.show();
                }
                if (applePayApiInitialButton) {
                    applePayApiInitialButton.show();
                }
            })
        }


        if (applePayApiButton) {
            applePayApiButton.hide();
            applePayApiButton.off().on('click', function() {
                if (conditionOfSales.length > 0 && !conditionOfSales[0].checked) {
                    $('[data-applepay-instant-checkout="errorMsg"]').removeClass('hidden');
                    conditionOfSales.addClass('is-invalid');
                    return;
                }
                // handling multiple clicks
                this.classList.add('disabled');
                this.setAttribute('disabled', true);
                setTimeout(function() {
                    applePayApiButton.removeClass('disabled');
                    applePayApiButton.removeAttr('disabled');
                }, 3000)
                prepareBasket(applePayApiButton.attr(ATTR_SKU), applePayApiButton.attr(ATTR_PAGE));
                if (parseFloat(request.total.amount) === 0) {
                    request.total.amount = '0.01';
                }
                // Start the payment session
                setSession(new ApplePaySession(APPLE_PAY_VERSION, request));
                // Begin session
                session.begin();
                updatedRequest = Object.assign({}, request);
            });
        }
        getRequest(action)

        if (applePayApiInitialButton) {
            applePayApiInitialButton.on('click', function() {
                $(this).addClass('hidden');
                var parent = $(this).parent('[data-applepay-instant-checkout="container"]');
                parent.find('[data-applepay-instant-checkout="content"]').removeClass('hidden');
                parent.siblings('[data-to-hide="button"]').addClass('hidden');
                // eslint-disable-next-line no-unused-vars
                conditionOfSales[0].addEventListener('click', function(event) {
                    if (conditionOfSales[0].checked) {
                        $('[data-applepay-instant-checkout="errorMsg"]').addClass('hidden');
                        conditionOfSales.removeClass('is-invalid');
                    } else {
                        $('[data-applepay-instant-checkout="errorMsg"]').removeClass('hidden');
                        conditionOfSales.addClass('is-invalid');
                    }
                });
            });
        }
    }
}

export function init() {
    launchApplePay(window.SFRA.Urls.applePayRedirect.action, window.location, window.ApplePaySession);
}
